import { formatarNumero_recebido_com_casa_decimais, formatarNumero_recebido_sem_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_cabecalho_4(item: any) {
  return {
    ...item,
    area: formatarNumero_recebido_com_casa_decimais(item.area),
    esperada: formatarNumero_recebido_com_casa_decimais(item.esperada),
    obtidas: formatarNumero_recebido_com_casa_decimais(item.obtidas)
  };
}

export function formatar_numeros_tabela_4(item: any) {
  return {
    ...item,
    volume_aplicacao: formatarNumero_recebido_com_casa_decimais(item.volume_aplicacao),
    area_tratada: formatarNumero_recebido_com_casa_decimais(item.area_tratada),
    n_autorizacao_atividade: formatarNumero_recebido_sem_casa_decimais(item.n_autorizacao_atividade)
  };
}